import { LABEL_IRIS } from 'src/templates/queries/iris';
import { JsonLdResult } from 'src/templates/queries/types';
import { getJsonLdResultLocalName } from 'src/utils/jsonld/getJsonLdResultLocalName';
import { getJsonLdResultPreferredValue } from 'src/utils/jsonld/getJsonLdResultPreferredValue';

export const getJsonLdResultLabel = (result: JsonLdResult) =>
  getJsonLdResultPreferredValue(result, LABEL_IRIS, getJsonLdResultLocalName);
